const $cartPayment = $('.js-cart-payment');
const $paymentSelector = $('.js-payment-selector');
const $paypalButton = $('.js-payment-paypal-button');

const cartPayment = {
  initialize() {
    if ($cartPayment.length) {
      this.createEvents();
    }
  },

  createEvents() {
    $paymentSelector.on('change', ({ currentTarget }) => {
      this.setPaymentMethod(currentTarget);
    });
  },

  setPaymentMethod(target) {
    const $target = $(target);
    const $dropdowns = $('.js-payment-dropdown');
    const $dropdown = $target.parent().find('.js-payment-dropdown');

    $paypalButton.toggle($target.hasClass('js-payment-paypal'));
    $dropdowns.hide();
    $dropdown.show();
  },
};

export default cartPayment;
